var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-circle",class:{
    'is-selected': _vm.isSelected,
    'is-scaled': _vm.scaleOnSelect && _vm.isSelected,
    },style:({
    'background-image': _vm.option.fillImage ? ("url(" + (_vm.option.fillImage) + ")") : '',
    'background-repeat': 'round',
    'background-color': _vm.option.fillColor ? ("" + (_vm.option.fillColor)) : ''
  })},[(_vm.option.icon)?_c('img',{attrs:{"src":_vm.option.icon}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }